import React from 'react';
import styled, { keyframes } from 'styled-components';
import { translate } from 'translations/i18n';

import { SkeletonLoader } from 'components/shared/forms/MultiselectPicker';

const fadeinup = keyframes`
  from {
    translate: 0px 10px;
    opacity: 0;
  }
  to {
    translate: 0px 0px;
    opacity: 1;
  }
`;

const AnimatedFadeContainer = styled.div`
  animation-duration: 0.5s;
  animation-name: ${fadeinup};
`;

export default function MediaSkeletonLoader() {
  return (
    <AnimatedFadeContainer>
      <SkeletonLoader
        accessibilityLabel={translate('common.loading')}
        placeholderCount={16}
      />
    </AnimatedFadeContainer>
  );
}
